 /*
 * Angular Module: trackerbase-app.services.all-office-types-service
 * Injected Service: AllOfficeTypes
 */

import angular from "angular";

import OfficeType from "../models/OfficeType";
import Assert from "tbAssert";
import TbAppConfigDataServiceModule from "tbClient/config/tb-app-config/TbAppConfigDataService";

const mHttpSvc = new WeakMap();
const mLogSvc = new WeakMap();
const mQSvc = new WeakMap();

const mTbServerBaseUrl = new WeakMap();

class AllOfficeTypesService {
    constructor($log, $http, $q, TbAppConfigDataService) {
        Assert.StrictAssert($log != null, "Assertion Failed: Missing log service dependency");
        Assert.StrictAssert($http != null, "Assertion Failed: Missing log service dependency");
        Assert.StrictAssert($q != null, "Assertion Failure: Missing Q Service Dependency");
        Assert.StrictAssert(TbAppConfigDataService != null, "Assertion Failed: Missing TrackerBase Application Configuration Data Service Dependency");

        mLogSvc.set(this, $log);
        mHttpSvc.set(this, $http);
        mQSvc.set(this, $q);
        mTbServerBaseUrl.set(this, TbAppConfigDataService.tbServerBaseUrl);

        this._AllOfficeTypes = [];
        this._OfficeTypesMap = new Map();
    }

    toString() {
        return "AllOfficeTypesService";
    }

    _prepareMap() {
        this._OfficeTypesMap.clear();
        this._AllOfficeTypes.forEach(function(ot) {
            this._OfficeTypesMap.set(
                ot.officeTypeName,
                ot
            );
        }, this);
    }

    RetrieveAllOfficeTypesAsync() {
        return mHttpSvc.get(this)({
            method: "GET",
            url: `${mTbServerBaseUrl.get(this)}/api/officetypes`
        }).then((response) => {
            if (response != null) {
                let responseData = response.data;
                if (responseData["Items"] != null) {
                    this._AllOfficeTypes.length = 0;
                    responseData.Items.forEach((svrOfficeType) => {
                        if (svrOfficeType != null) {
                            let bareOfficeType = OfficeType.FromServerOfficeType(svrOfficeType, null);
                            this._AllOfficeTypes.push(bareOfficeType);
                        }
                    });
                    this._prepareMap();
                    return true;
                } else {
                    this._AllOfficeTypes.length = 0;
                    return mQSvc.get(this).reject("Invalid office types response data");
                }
            }
            else {
                this._AllOfficeTypes.length = 0;
                return mQSvc.get(this).reject("Invalid office types response");
            }
        }, (response) => {
            this._AllOfficeTypes.length = 0;
            mLogSvc.get(this).error("Office Types retrieval failed.");
            return mQSvc.get(this).reject(response);
        });
    }

    PreLoadOfficeTypesData() {
        return this.RetrieveAllOfficeTypesAsync().then(
            (success) => {
                mLogSvc.get(this).debug(`Office Types Information Pre-Load Complete: ${success}`);
            },
            () => {
                mLogSvc.get(this).error("Office Types Information Pre-Load Failed.");
            });
    }

    getFromId(otId) {
        return OfficeType.Copy(this._AllOfficeTypes[(otId - 1)]);
    }

    getFromName(otName) {
        return OfficeType.Copy(this._OfficeTypesMap.get(otName));
    }

    get AvailableOfficeTypes() {
        return this._AllOfficeTypes.map(ot => OfficeType.Copy(ot));
    }

    GetOfficeTypes() {
        let officeTypesDataPromise = null;
        if (this._AllOfficeTypes.length > 0) {
            officeTypesDataPromise = mQSvc.get(this).when(this.AvailableOfficeTypes);
        }
        else {
            officeTypesDataPromise = this.RetrieveAllOfficeTypesAsync().then(
                () => this.AvailableOfficeTypes,
                (errorResponse) => {
                    return mQSvc.get(this).reject(errorResponse);
                }
            );
        }
        return officeTypesDataPromise;
    }
}

AllOfficeTypesService.$inject = [
    "$log",
    "$http",
    "$q",
    "TbAppConfigDataService"
];

export default angular
    .module("trackerbase-app.services.all-office-types-service", [
        TbAppConfigDataServiceModule
    ])
    .service("AllOfficeTypes", AllOfficeTypesService)
    .name;




//////////////////
// WEBPACK FOOTER
// ./src/services/AllOfficeTypesService.js
// module id = vPYk
// module chunks = 1